import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import {
    Button,
    Card,
    Checkbox,
    Divider,
    List,
    Popconfirm,
    Progress,
    Typography,
} from 'antd'
import StackCompletionBar from './StackCompletionBar'
import ShowFilter from './ShowFilter'

// --- Helpers ---
const formatDate = (d) =>
    new Date(d).toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
    })

const TestRunItem = (props) => {
    const {
        selectedIds,
        item,
        token,
        toggleOne,
        onDelete,
        onEdit,
        percent,
        strokeColor,
        percents,
    } = props
    return (
        <List.Item style={{ padding: 0, border: 'none' }}>
            <Card
                size="small"
                bodyStyle={{ padding: 16 }}
                style={{
                    width: '100%',
                    marginBottom: 12,
                    borderRadius: 10,
                    borderColor: token.colorBorder,
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        gap: 16,
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            gap: 12,
                            alignItems: 'flex-start',
                            flex: 1,
                            minWidth: 0,
                        }}
                    >
                        {/* <Checkbox
                            checked={selectedIds.includes(item?._id)}
                            onChange={(e) =>
                                toggleOne(item?._id, e.target.checked)
                            }
                            style={{ marginTop: 6 }}
                        /> */}
                        {/* <Avatar
                                            icon={<FileTextOutlined />}
                                            style={{
                                                backgroundColor: '#722ED1',
                                            }}
                                            size={28}
                                        /> */}
                        <div style={{ minWidth: 0 }}>
                            <Typography.Text
                                ellipsis={{
                                    tooltip: item?.name,
                                }}
                                style={{
                                    display: 'block',
                                    fontSize: 15,
                                    fontWeight: 700,
                                }}
                            >
                                {item?.name}
                            </Typography.Text>

                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    flexWrap: 'wrap',
                                }}
                            >
                                <Typography.Text type="secondary">
                                    By {item?.createdBy?.name || ''} on{' '}
                                    {formatDate(item?.createdAt)}
                                </Typography.Text>
                                <Divider type="vertical" />
                                <Typography.Link
                                    onClick={() => onEdit(item?._id)}
                                >
                                    <EditOutlined
                                        style={{
                                            marginRight: 6,
                                        }}
                                    />
                                    Edit
                                </Typography.Link>
                            </div>

                            <Typography.Text
                                type="secondary"
                                style={{
                                    display: 'block',
                                    marginTop: 2,
                                }}
                            >
                                {item?.passed} Passed, {item?.pending} pending,{' '}
                                {item?.retest} Retest and {item?.failed} Failed.
                            </Typography.Text>

                            <Typography.Text
                                type="secondary"
                                style={{
                                    display: 'block',
                                    marginTop: 2,
                                }}
                            >
                                Group By :{' '}
                                {/* {item?.dueDate
                                    ? `Due ${formatDate(item?.dueDate)}`
                                    : 'No due date'} */}
                                <ShowFilter data={item?.filters || {}} />
                            </Typography.Text>
                        </div>
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 12,
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 8,
                                width: 260,
                            }}
                        >
                            <div style={{ flex: 1 }}>
                                <StackCompletionBar
                                    percents={percents}
                                    height={14}
                                />
                            </div>
                            <Typography.Text strong>
                                {Math.round(percents.completed)}%
                            </Typography.Text>
                        </div>

                        <Popconfirm
                            title="Delete this test run?"
                            okText="Delete"
                            okButtonProps={{ danger: true }}
                            onConfirm={() => onDelete(item?._id)}
                        >
                            <Button
                                type="text"
                                danger
                                icon={<DeleteOutlined />}
                            />
                        </Popconfirm>
                    </div>
                </div>
            </Card>
        </List.Item>
    )
}

export default TestRunItem
